export const getArrayError = (error: string) => {
  const arrayError: string[] = [];

  // @ts-ignore
  arrayError['FINAL_FORM/array-error'] = error;

  return arrayError;
};
